import type {PreviewCtaComponentProps} from '@cohort/merchants/apps';
import ActionCtaPreview from '@cohort/merchants/apps/common/ActionCtaPreview';
import type {CohortVisitLinkTriggerStruct} from '@cohort/shared/apps/cohort/triggers/visitLink';
import {useTranslation} from 'react-i18next';

const CohortVisitLinkTriggerIntegrationActionCtaComponentPreview: React.FC<
  PreviewCtaComponentProps<CohortVisitLinkTriggerStruct>
> = ({localizationConfig}) => {
  const {t} = useTranslation('app-cohort', {
    keyPrefix: 'triggerIntegrations.visit-link',
    lng: localizationConfig.desiredLanguage,
  });
  return <ActionCtaPreview text={t('ctaTitle')} />;
};

export default CohortVisitLinkTriggerIntegrationActionCtaComponentPreview;
